import { createContext, useEffect, useState, } from 'react';
import axios from 'axios';
import { responseGet, globalSettings, isUndNullEmp } from '../../helpers/settings';
import { userModelGet } from '../../models/users/user';
export const AuthContext = createContext();

const { app, localStorage: settingsLs, } = globalSettings;
const { backend, } = app;

export default function AuthProvider({ children }) {

    const [user, setUser] = useState(
        JSON.parse(localStorage?.getItem(settingsLs?.userId)) || null
    );

    useEffect(() => {
        try {
            localStorage?.setItem(settingsLs?.userId, JSON.stringify(user));
        } catch (ex) {
            localStorage?.removeItem(settingsLs?.userId);
        }
    }, [user]);

    const contextValue = {
        user,
        async loginAsync({
            email = '',
            password = '',
            rememberMe = false,
            saveUser = false,
            languageId = 'en',
            recaptchaToken = '',
            subMethod = '',
        }) {
            const currentMethod = 'AuthProvider - (login)';
            let response = responseGet();
            try {
                //#region variables
                let result;
                let userData = {
                    userVzLa: userModelGet({}),
                    token: {},
                    user: {},
                };
                let tokenData = {};
                //let userUpdated = {};

                const dataObj = {
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlLogin}/`,
                    email: email,
                    password: password,
                    rememberMe: rememberMe,
                    recaptchaToken: recaptchaToken,
                    languageId: languageId,
                };
                //#endregion variables

                //#region Loggin
                result = await axios?.post(
                    dataObj?.url,
                    dataObj
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    this.logout({
                        subMethod: currentMethod,
                    });
                    return response;
                }

                userData = response?.result;
                tokenData = userData?.token;
                userData.user.tokenVzLaCondominios = tokenData;
                //#endregion Loggin

                //#region old code
                ////#region update user (firebase)
                // if (userData.userVzLa !== null) {
                //     if (isEmpty(userData.user.displayName)) {
                //         //response = await updateUserAsync(userData.userVzLa);
                //         userUpdated = {
                //             displayName: `${userData.userVzLa.firstName}, ${userData.userVzLa.lastName}`,
                //             photoURL: userData.userVzLa.photoURL,
                //             phoneNumber: userData.userVzLa.phoneNumber,
                //         };

                //         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlAccounts}/${userData.user.uid}`, localUserUpdate);
                //         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}/${userData.user.uid}`, userUpdated);
                //         response = result.data;

                //         if (!response?.isSuccess || response?.isWarning) {
                //             //this.logout();
                //             this.removeUser();
                //             return response;
                //         }

                //         //#region update user data (local)

                //         userData.user.displayName = userUpdated.displayName;
                //         userData.user.photoURL = userUpdated.photoURL;
                //         userData.user.phoneNumber = userUpdated.phoneNumber;
                //         response = this.updateLocalUser(userData.user);
                //         if (!response?.isSuccess || response?.isWarning) {
                //             //this.logout();
                //             this.removeUser();
                //             return response;
                //         }

                //         //#endregion update user data (local)
                //     }
                // }
                ////#endregion update user (firebase)
                //#endregion old code

                //#region data save (local data)
                if (saveUser) {
                    setUser(userData.user);
                } else {
                    this.removeUser({
                        subMethod: currentMethod,
                    });
                }
                //#endregion data save (local data)

                response.result = userData;
            } catch (ex) {
                this.removeUser({
                    subMethod: currentMethod,
                });
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                console?.error(response);
            }
            return response;
        },
        logout({
            subMethod = '',
        }) {
            const currentMethod = 'AuthProvider - (logout)'
            let response = responseGet();
            try {
                response = this.removeUser({
                    subMethod: currentMethod,
                });
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                console?.error(response);
            }
            return response;
        },
        isLoged() {
            return !!user;
        },
        removeUser({
            subMethod = '',
        }) {
            const currentMethod = 'AuthProvider - (removeUser)';
            let response = responseGet();
            try {
                localStorage?.removeItem(settingsLs?.userId);
                setUser(null);
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                console?.error(response);
            }
            return response;
        },
        //#region old code
        // updateLocalUser() {
        //     let response = responseGet();
        //     try {
        //         localStorage?.removeItem(settingsLocalStorage?.userId);
        //         setUser(getCurrentUser());
        //         localStorage?.setItem(settingsLocalStorage?.userId, JSON.stringify(user));
        //         response.result = user;
        //     } catch (ex) {
        //         response.isSuccess = false;
        //         response.msgType = -1;
        //         response.msgText = `Method: AuthProvider - (updateLocalUser)</br>`;
        //         response.msgText += `Error: ${ex?.message}`;
        //         console?.error(response);
        //     }
        //     return response;
        // },
        //#endregion old code
        updateLocalUser({
            userNew = {},
            subMethod = '',
        }) {
            const currentMethod = 'AuthProvider - (updateLocalUser)';
            let response = responseGet();
            try {
                localStorage?.removeItem(settingsLs?.userId);
                setUser(userNew);
                localStorage?.setItem(settingsLs?.userId, JSON.stringify(userNew));
                response.result = userNew;
            } catch (ex) {
                response.msgType = -1;
                response.isSuccess = false;
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`;
                }
                response.msgText += `Error: ${ex?.message}`;
                console?.error(response);
            }
            return response;
        },
        //#region old code
        // currentUserGet() {
        //     let response = responseGet();
        //     try {
        //         response.result = getCurrentUser();
        //     } catch (ex) {
        //         response.isSuccess = false;
        //         response.msgType = -1;
        //         response.msgText = `Method: AuthProvider - (currentUserGet)</br>`;
        //         response.msgText += `Error: ${ex?.message}`;
        //         console?.error(response);
        //     }
        //     return response;
        // },
        //#endregion old code
    };

    return <AuthContext.Provider value={contextValue}>
        {children}
    </AuthContext.Provider>
}